Input for a single candidate in a summaries request.
